export const selectionColumnWidth = 48;
export const actionColumnWidth = 96;

export interface RowBase {
  readonly guid: string;
}

export interface ColumnData<TRow extends RowBase> {
  readonly key: string;
  readonly title: string;
  readonly width: number;
  readonly getCellValue: (row: TRow) => string;
  readonly sortByMapping?: (row: TRow) => string | number;
  readonly compare?: (a: string, b: string) => number;
  readonly getUpdatedRowWithEdit?: (row: TRow, newValue: string) => TRow;
  readonly getEditValue?: (row: TRow) => string;
  readonly validateEditValue?: (newValue: string) => string | undefined;
  readonly editStartAdornment?: string;
  readonly filterType?: 'range' | 'text' | 'select';
  readonly filterLabel?: string;
  readonly rangeFilterLabels?: {
    readonly min: string;
    readonly max: string;
  };
  readonly groupable?: boolean;
  readonly getGroupValue?: (row: TRow) => string;
}

export interface Sorting {
  readonly columnKey: string;
  readonly direction: 'asc' | 'desc';
}

export interface RangeFilter {
  readonly min?: string;
  readonly max?: string;
}

export type FilterValue = string | readonly string[] | RangeFilter | undefined;

export function isRangeFilter(filterValue: FilterValue): filterValue is RangeFilter {
  return Boolean(filterValue && typeof filterValue === 'object' && !Array.isArray(filterValue));
}

export interface Filters {
  readonly [columnKey: string]: FilterValue;
}

export interface RowEdits {
  readonly [columnKey: string]: string | undefined;
}

export type DisplayRow<TRow extends RowBase> =
  | { readonly type: 'price'; readonly row: TRow }
  | { readonly type: 'group'; readonly key: string; readonly label: string; readonly rows: readonly TRow[] };
